import axios from 'axios'

// http://www.axios-js.com/zh-cn/
const httpInstance = axios.create({
  timeout: 15000
})

export default httpInstance
